import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { connect } from 'react-redux';
import { change, reduxForm } from 'redux-form';
import { compose, lifecycle, withHandlers, withState } from 'recompose';
import { get } from 'lodash';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import ComposedUpload from '@inqool/uas-web-core/es/components/controls/Upload';

import { Preview } from '@components/form/Upload/Upload';
import { InlineGridField, InlineGrid } from '@components/form';
import { photosGridColumns } from './_eventsColumns';
import { Loader } from '@components/loader';
import { EventsFormPhotosMultiForm } from '@modules/events/EventsFormPhotosMultiForm';

const mapStateToProps = state => ({
  eventPhotos: get(state, 'form.module-events.values.eventPhotos') || [],
  photos: get(state, 'form.module-events-photos.values.photos') || []
});

const mapDispatchToProps = dispatch => ({
  addPhotosToEvent: photos => dispatch(change('module-events', 'eventPhotos', photos)),
  savePhotos: photos => dispatch(change('module-events-photos', 'photos', photos))
});

let inProgressCount = 0;

const enhance = compose<any, any>(
  reduxForm({ form: 'module-events-photos', initialValues: { photos: [] } }),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withState('inProgress', 'setInProgress', false),
  withHandlers({
    updateProgress: ({ setInProgress }) => value => {
      inProgressCount = value < 0 ? 0 : value;
      setInProgress(!!inProgressCount);
    }
  }),
  withHandlers({
    onChange: ({ photos, savePhotos, updateProgress }) => data => {
      savePhotos([...photos, { file: data, note: '' }]);
      updateProgress(inProgressCount - 1);
    },
    onSubmit: ({ eventPhotos, photos, addPhotosToEvent, closeItem, setDisableSps }) => () => {
      addPhotosToEvent([...eventPhotos, ...photos]);
      setDisableSps(true);
      closeItem();
    }
  }),
  lifecycle<any, any>({
    componentWillUnmount() {
      this.props.updateProgress(0);
    }
  })
);

const View: React.SFC<any> = ({ photos, closeItem, onChange, onSubmit, inProgress, updateProgress }) => {
  return (
    <div style={{ margin: '15px', maxHeight: '500px', overflow: 'auto' }}>
      {!!inProgress && <Loader />}
      <Grid fluid={true}>
        <Row className="without-min-width">
          <Col md={12}>
            <InlineGridField
              component={InlineGrid}
              name="photos"
              columns={photosGridColumns}
              Form={EventsFormPhotosMultiForm}
              ActionBar={() => (
                <div style={{ display: 'flex', alignItems: 'center', height: '36px', cursor: 'pointer' }}>
                  <ComposedUpload
                    value={null}
                    url="/metropolis/api/files/"
                    accept="image/*,video/*"
                    View={Preview}
                    onChange={onChange}
                    fullWidth={true}
                    multiple={true}
                    onStart={f => updateProgress(inProgressCount + f.length)}
                    onError={() => updateProgress(inProgressCount - 1)}
                    onAbort={() => updateProgress(inProgressCount - 1)}
                  />
                </div>
              )}
              showCheckboxes={true}
              deleting={true}
              editing={true}
              adding={false}
            />
          </Col>
        </Row>
      </Grid>

      <Button
        label="Uložit"
        style={{ margin: '16px 0 16px 16px' }}
        onClick={onSubmit}
        primary={true}
        disabled={!photos || !photos.length}
      />
      <Button label="Zavřít" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
    </div>
  );
};

export const EventsFormPhotosMultipleUploader = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormPhotosMultipleUploader.tsx